import React from "react";
import "./reviewCompleted.scss";
import { TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL, CIGNA_URL } from "../../constants";
import CignaLogo from "../CignaLogo/CignaLogo.js";

const ReviewCompleted = () => {
  return (
    <div className="review-completed-screen">
    <div className="review-completed-wrapper">
      <div className="card">
        <div className="logo-header d-flex align-items-center logo-section">
          <CignaLogo className="h-14 w-auto mb-6" />
        </div>
      </div>
      <div className="review-completed-parent review-container p-4">
        <h1 className="review-completed">
          You have already completed this review.
        </h1>
        <h2 className="boldParaText">
          Interested in learning more about your healthcare benefits?
        </h2>
        <p>With myCigna you can:</p>
        <ul className="review-list">
          <li> Get answers to claim questions</li>
          <li> Search in-network providers and compare costs</li>
          <li>Check your coverage details</li>
        </ul>
        <a
          href="https://my.cigna.com/web/secure/my"
          target="_blank"
          rel="noreferrer"
          className="btn btn-primary med-pill"
        >
          Login
        </a>
      </div>
      


    </div>



   <div className="footer-wrapper">
    <div className="container footer">
        <p className="mt-2 footerParaText">
          This does not supplement or replace Cigna's current complaint and
          quality monitoring process. For any specific issues or concerns that
          you would like to share with Cigna for further review, please call
          1.800.Cigna24 or 1.800.244.6224.
        </p>
        <div className="reviewLinks">
          <a
            href={CIGNA_URL}
            target="_blank"
            rel="noreferrer"
            className="mx-2 text-primary"
          >
            Cigna
          </a>
          <span>|</span>
          <a
            href={TERMS_AND_CONDITIONS_URL}
            target="_blank"
            rel="noreferrer"
            className="mx-2"
          >
            Terms and Conditions
          </a>
          <span>|</span>
          <a
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noreferrer"
            className="mx-2"
          >
            Privacy Policy
          </a>
        </div>
      </div>
      </div>
    </div>
  );
};

export default ReviewCompleted;
